const PRIVILEGE = {
  VIEW_DASHBOARD: "VIEW_DASHBOARD",
  VIEW_DAILY_ANALYSIS: "VIEW_DAILY_ANALYSIS",
  VIEW_USER_ANALYSIS: "VIEW_USER_ANALYSIS",
  VIEW_STATISTIC: "VIEW_STATISTIC",
  EXPORT_SHIFT: "EXPORT_SHIFT",
  GENERATE_SHIFT: "GENERATE_SHIFT",
  VIEW_SALARY: "VIEW_SALARY",
  IMPORT_SALARY: "IMPORT_SALARY",
  SEND_MAIL: "SEND_MAIL",

  VIEW_TIME_CHECK: "VIEW_TIME_CHECK",
  GET_SYSTEM_CODE: "GET_SYSTEM_CODE",
  SUBMIT_TIMELINE: "SUBMIT_TIMELINE",
  SUBMIT_TIMELINE_WITH_CODE: "SUBMIT_TIMELINE_WITH_CODE",
  SUBMIT_TIMELINE_BY_USER_ID: "SUBMIT_TIMELINE_BY_USER_ID",
  SUBMIT_TIMELINE_BY_FACE_ID: "SUBMIT_TIMELINE_BY_FACE_ID",
  SUBMIT_TIMELINE_BY_TOKEN: "SUBMIT_TIMELINE_BY_TOKEN",

  VIEW_CALENDAR: "VIEW_CALENDAR",
  GET_ALL_USER_SHIFT_TYPES: "GET_ALL_USER_SHIFT_TYPES",
  CREATE_USER_SHIFT_TYPE: "CREATE_USER_SHIFT_TYPE",
  APPROVE_USER_SHIFT_TYPE: "APPROVE_USER_SHIFT_TYPE",
  DELETE_USER_SHIFT_TYPE: "DELETE_USER_SHIFT_TYPE",

  VIEW_PROFILE: "VIEW_PROFILE",
  VIEW_WORK_SHIFT: "VIEW_WORK_SHIFT",
  VIEW_PAYROLL: "VIEW_PAYROLL",
  VIEW_LEAVE_TYPE: "VIEW_LEAVE_TYPE",
  MODIFY_LEAVE_TYPE: "MODIFY_LEAVE_TYPE",

  VIEW_SETTING: "VIEW_SETTING",
  VIEW_SHIFT: "VIEW_SHIFT",
  MODIFY_SHIFT: "MODIFY_SHIFT",
  VIEW_HOLIDAY: "VIEW_HOLIDAY",
  MODIFY_HOLIDAY: "MODIFY_HOLIDAY",
  VIEW_SETTING_LEAVE_TYPE: "VIEW_SETTING_LEAVE_TYPE",
  MODIFY_SETTING_LEAVE_TYPE: "MODIFY_SETTING_LEAVE_TYPE",
  VIEW_DAILY_REPORT_TEMPLATE: "VIEW_DAILY_REPORT_TEMPLATE",
  MODIFY_DAILY_REPORT_TEMPLATE: "MODIFY_DAILY_REPORT_TEMPLATE",
  VIEW_QR_CODE: "VIEW_QR_CODE",
  MODIFY_QR_CODE: "MODIFY_QR_CODE",

  VIEW_DAILY_REPORT: "VIEW_DAILY_REPORT",
  VIEW_MY_DAILY_REPORT: "VIEW_MY_DAILY_REPORT",
  VIEW_ALL_DAILY_REPORT: "VIEW_ALL_DAILY_REPORT",
  EDIT_USER_REASON: "EDIT_USER_REASON",

  VIEW_MEMBER_WORKED_SHIFT: "VIEW_MEMBER_WORKED_SHIFT",
};

export default PRIVILEGE;
